/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProductServiceOutput } from './ProductServiceOutput';
import {
    ProductServiceOutputFromJSON,
    ProductServiceOutputFromJSONTyped,
    ProductServiceOutputToJSON,
    ProductServiceOutputToJSONTyped,
} from './ProductServiceOutput';

/**
 * 
 * @export
 * @interface ProductServiceResponse
 */
export interface ProductServiceResponse {
    /**
     * the list of products and services
     * @type {Array<ProductServiceOutput>}
     * @memberof ProductServiceResponse
     */
    productsServicesOutput?: Array<ProductServiceOutput>;
}

/**
 * Check if a given object implements the ProductServiceResponse interface.
 */
export function instanceOfProductServiceResponse(value: object): value is ProductServiceResponse {
    return true;
}

export function ProductServiceResponseFromJSON(json: any): ProductServiceResponse {
    return ProductServiceResponseFromJSONTyped(json, false);
}

export function ProductServiceResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductServiceResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'productsServicesOutput': json['productsServicesOutput'] == null ? undefined : ((json['productsServicesOutput'] as Array<any>).map(ProductServiceOutputFromJSON)),
    };
}

export function ProductServiceResponseToJSON(json: any): ProductServiceResponse {
    return ProductServiceResponseToJSONTyped(json, false);
}

export function ProductServiceResponseToJSONTyped(value?: ProductServiceResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'productsServicesOutput': value['productsServicesOutput'] == null ? undefined : ((value['productsServicesOutput'] as Array<any>).map(ProductServiceOutputToJSON)),
    };
}

